export function getCsrfHeaders() {
  const csrfToken = document.querySelector('meta[name="_csrf"]')?.content;
  const csrfHeader = document.querySelector('meta[name="_csrf_header"]')?.content;
  const headers = {};
  if (csrfHeader && csrfToken) {
    headers[csrfHeader] = csrfToken;
  }
  return headers;
}

export async function post(url, formData) {
  const response = await fetch(url, {
    method: "POST",
    headers: getCsrfHeaders(),
    body: formData,
  });
  return response;
}
